import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import uploadcare from 'uploadcare-widget';
import { languages } from '../../constants';
import './UploadcareDialog.css';
var fileDragLanguage = {
  en: 'drag & drop<br>any image file',
  es: 'Arrastra un archivo aquí',
  pt: 'Arraste um arquivo aqui'
};

var UploadcareDialog =
/*#__PURE__*/
function (_Component) {
  _inherits(UploadcareDialog, _Component);

  function UploadcareDialog(props) {
    var _this;

    _classCallCheck(this, UploadcareDialog);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UploadcareDialog).call(this, props));
    _this.internalUploadcare = null;
    uploadcare.plugin(function (internal) {
      return _this.internalUploadcare = internal;
    });
    return _this;
  }

  _createClass(UploadcareDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.rebuildUploadcare();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.rebuildUploadcare();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.language !== nextProps.language;
    }
  }, {
    key: "rebuildUploadcare",
    value: function rebuildUploadcare() {
      var _this2 = this;

      var uploadcareLanguage = languages[this.props.language].uploadcare;
      this.internalUploadcare.locale.rebuild({
        locale: uploadcareLanguage,
        localeTranslations: {
          dialog: {
            tabs: {
              file: {
                drag: fileDragLanguage[uploadcareLanguage]
              }
            }
          }
        }
      });
      var _this$props = this.props,
          value = _this$props.value,
          onUploadComplete = _this$props.onUploadComplete;
      this.widget = uploadcare.Widget(this.uploader);

      if (typeof value !== 'undefined') {
        this.widget.value(value);
      }

      if (typeof onUploadComplete === 'function') {
        this.widget.onUploadComplete(onUploadComplete);
      }

      this.widget.onDialogOpen(function (dialog) {
        return _this2.dialog = dialog;
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.dialog) {
        this.dialog.reject();
      }

      var widgetElement = uploadcare.jQuery(this.uploader).next('.uploadcare--widget');
      var widget = widgetElement.data('uploadcareWidget');

      if (widget && widget.inputElement === this.uploader) {
        widgetElement.remove();
      }
    }
  }, {
    key: "getInputAttributes",
    value: function getInputAttributes() {
      var attributes = _extends({}, this.props);

      delete attributes.value;
      delete attributes.onChange;
      delete attributes.onUploadComplete;
      delete attributes.dispatch;
      return attributes;
    }
  }, {
    key: "openDialog",
    value: function openDialog() {
      this.widget.openDialog();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var attributes = this.getInputAttributes();
      return React.createElement('input', _extends({
        type: 'hidden',
        'data-preview-step': true,
        'data-crop': attributes.crop || '1:1',
        'data-images-only': true,
        ref: function ref(input) {
          return _this3.uploader = input;
        }
      }, attributes));
    }
  }]);

  return UploadcareDialog;
}(Component);

UploadcareDialog.propTypes = {
  language: PropTypes.string,
  value: PropTypes.string,
  crop: PropTypes.string,
  onUploadComplete: PropTypes.func
};
UploadcareDialog.defaultProps = {
  language: 'en',
  crop: '1:1'
};
export default UploadcareDialog;